import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

/**
 * BioConnect theme preset for PrimeUI components.
 * Customization for design tokens exposed by PrimeNG. 
 */
const BioConnectPreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{sky.50}',
            100: '{sky.100}',
            200: '{sky.200}',
            300: '{sky.300}',
            400: '{sky.400}',
            500: '{sky.500}',
            600: '{sky.600}',
            700: '{sky.700}',
            800: '{sky.800}',
            900: '{sky.900}',
            950: '{sky.950}'
        },
        colorScheme: {
            light: {
                semantic: {
                    highlight: {
                        background: '{primary.700}',
                        color: '{primary.50}',
                    },
                    text: {
                        hoverColor: '{primary.600}',
                    },
                    contentHoverColor: '{surface.400}',
                    focusRing: {
                        shadow: 'none'
                    }
                },
                text: {
                    hoverColor: '{primary.600}',
                }
            }
        }
    },
    components: {
        button: {
            root: {
                sm: {
                    paddingX: '0.25rem',
                    paddingY: '0.25rem',
                },
                iconOnlyWidth: '2rem',
                primary: {
                    background: '{primary.700} !important',
                    color: '{primary.50}',
                    hoverBackground: '{primary.800} !important',
                    hoverColor: '{primary.50}',
                    activeBackground: '{primary.800}',
                    activeColor: '{primary.50}',
                    borderColor: '{primary.700} !important',
                },
            },

            text: {
                primary: {
                    color: '{primary.700} !important',
                    hoverBackground: '{primary.800}',
                    activeBackground: '{primary.800}',
                }
            },
            outlined: {
                primary: {
                    color: '{primary.700} !important',
                    borderColor: '{primary.700} !important',
                }
            },
            link: {
                color: '{primary.700} !important', 
                hoverColor: '{primary.800} !important',
            }
        },
        radiobutton: {
            icon: {
                size: '0.75rem'
            }
        },
        inputtext: {
            // Came from access.control.css ng-deep
            root: {
                paddingX: '0.5rem',
                paddingY: '0.5rem',
            }
        },
        select: {
            // Came from access.control.css ng-deep
            root: {
                paddingX: '0.5rem',
                paddingY: '0.5rem',
            },
            option: {
                padding: '0.3rem 0.8rem',
                color: 'black',
                focusColor: '{primary.700}',
            },
            optionGroup: {
                padding: '0.3rem 0.8rem'
            },
        },
        breadcrumb: {
            root: {
                padding: '0.5rem 0.5rem 0.5rem 1rem'
            },
            item: {
                hoverColor: '{primary.700}',
                icon: {
                    hoverColor: '{primary.700}',
                },
                gap: '0.375rem'
            }
        },
        multiselect: {
            // // from curation.css, need to add align items start
            option: {
                padding: '0.3rem 0.8rem',
                color: 'black',
            }
        },
        accordion: {
            header: {
                padding: '0.75rem'
            }
        },
        datatable: {
            row: {
                selectedBackground: '{primary.100}',
                selectedColor: 'white',
                hoverColor: '{surface.800}',
            },
            headerCell: {
                hoverColor: '{surface.800}',
                hoverBackground: '{surface.100}'
            }
        },
        chip: {
            colorScheme: {
                light: {
                    root: {
                        color: '{primary.700}'
                    },
                    removeIcon: {
                        color: '{primary.700}'
                    }
                }
            }
        },
        listbox: {
            option: {
                padding: '0.2rem 1rem',
                selectedColor: '{primary.700}',
            },
            optionGroup: {
                padding: '0.5rem 0rem',
            },
        },
        checkbox: {
            root: {
                checkedBackground: '{primary.700}',
            }
        },
        dialog: {
            footer: {
                padding: '0.75rem'
            }
        },
        menu: {
            item: {
                focusColor: '{primary.700}',
            }
        },
        menubar: {
            root: {
                padding: '0',
            },
            item: {
                focusBackground: '{primary.50} !important',
                activeColor: '{primary.700}',
                activeBackground: '{primary.50} !important',
            }
        }
    },
    extend: {
        button: {
            // Used in data schema details for the ellipsis menu toggle 
            menubutton: {
                background: 'transparent',
                color: '{primary.50}',
                hoverColor: '{primary.50}',
                borderColor: 'transparent'
            }
        },
        accordion: {
            contentFlushPadding: '0rem'
        },
    }
});

export default BioConnectPreset;